import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, Zap, Printer, Download } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    Icon: Check,
    text: 'Más de 1000 actividades'
  }, {
    Icon: Zap,
    text: 'Planificaciones listas'
  }, {
    Icon: Printer,
    text: 'Material imprimible'
  }, {
    Icon: Download,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-5 pb-12 lg:pt-12 lg:pb-20 bg-white overflow-hidden" data-id="element-93">
      {/* Subtle background accent */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-50 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3 opacity-70 pointer-events-none" data-id="element-94"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-96">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-50 text-brand-700 font-bold text-[11px] sm:text-xs uppercase tracking-wider mb-4 border border-brand-100" data-id="element-97">
            <span className="text-sm leading-none" data-id="element-98">🎨</span>
            Para docentes de Arte
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-extrabold text-ink-900 leading-[1.05] mb-4 tracking-tight" data-id="element-99">
            Resolvé todo tu{' '}
            <span className="text-brand-500" data-id="element-100">año de arte en 5 minutos</span>
          </h1>
        </motion.div>

        {/* Product mockup image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mb-5" data-id="element-101">
          <div className="absolute inset-0 bg-brand-200/40 rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-102"></div>
          <img src="https://cdn.magicpatterns.com/uploads/6k7L2pn6oPnrMBQCA6LZsd/ChatGPT_Image_31_may_2026,_21_50_12-Photoroom.png" alt="Mega Pack Artística Lista - 6 tomos, cuadernos, tablet y celular" className="relative z-10 w-full max-w-[260px] sm:max-w-md lg:max-w-2xl mx-auto drop-shadow-2xl" data-id="element-103" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-104">
          <p className="text-base sm:text-lg lg:text-xl text-ink-600 mb-5 leading-relaxed max-w-2xl mx-auto" data-id="element-105">
            Todo el material que necesitás para enseñar Arte en Secundaria. Más
            de{' '}
            <strong className="text-ink-900" data-id="element-106">
              1.000 actividades, proyectos y planificaciones
            </strong>{' '}
            listas para usar.
          </p>

          <button onClick={scrollToPricing} className="group w-full sm:w-auto bg-brand-500 hover:bg-brand-600 text-white text-base sm:text-lg font-extrabold py-4 sm:py-5 px-8 sm:px-10 rounded-2xl shadow-cta hover:shadow-xl transition-all transform hover:-translate-y-0.5 inline-flex items-center justify-center gap-3" data-id="element-107">
            QUIERO ACCEDER AHORA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-108" />
          </button>

          <p className="mt-3 text-xs sm:text-sm text-ink-500" data-id="element-109">
            🔒 Pago 100% seguro · Garantía de 7 días
          </p>

          {/* Trust badges */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mt-8 max-w-3xl mx-auto" data-id="element-110">
            {badges.map((b, i) => {
            const Icon = b.Icon;
            return <div key={i} className="flex items-center gap-2 text-xs sm:text-sm font-semibold text-ink-700 bg-white border border-ink-100 px-3 py-2 rounded-xl shadow-soft" data-id="element-111">
                  <div className="w-5 h-5 rounded-full bg-brand-50 text-brand-600 flex items-center justify-center shrink-0" data-id="element-112">
                    <Icon className="w-3 h-3" data-id="element-113" />
                  </div>
                  <span className="text-left leading-tight" data-id="element-114">{b.text}</span>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}